import { render } from "./HjpOpenDataList.vue?vue&type=template&id=29e4fb3f&ts=true"
import script from "./HjpOpenDataList.vue?vue&type=script&lang=ts"
export * from "./HjpOpenDataList.vue?vue&type=script&lang=ts"

import "./HjpOpenDataList.vue?vue&type=style&index=0&id=29e4fb3f&lang=scss"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__